/**
 * @generated SignedSource<<4970d18b5c86ca070279ec2f697bb3cf>>
 * @relayHash 1c57182c48cac0e1935dff63eed52f97
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOTimeGranularity = "DAY" | "FIFTEEN_MINUTES" | "HOUR" | "MINUTES_15" | "MONTH" | "WEEK" | "%future added value";
export type PerformanceNetworkViewQuery$variables = {
  cloudId: string;
  dimension?: string | null;
  endDate: AGG$DateTime;
  granularity?: JiraCFOTimeGranularity | null;
  startDate: AGG$DateTime;
};
export type PerformanceNetworkViewQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceMonitoringHorizontalBarChart" | "PerformanceNetworkUserCharts">;
};
export type PerformanceNetworkViewQuery = {
  response: PerformanceNetworkViewQuery$data;
  variables: PerformanceNetworkViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": "network_downlink",
  "kind": "LocalArgument",
  "name": "dimension"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": "DAY",
  "kind": "LocalArgument",
  "name": "granularity"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v7 = {
  "kind": "Variable",
  "name": "granularity",
  "variableName": "granularity"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Literal",
  "name": "metrics",
  "value": [
    {
      "aggregation": {
        "type": "COUNT_DISTINCT"
      },
      "name": "account_id"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v12 = {
  "concreteType": "JiraCFODimension",
  "kind": "LinkedField",
  "name": "dimensions",
  "plural": true,
  "selections": (v11/*: any*/)
},
v13 = {
  "concreteType": "JiraCFOMetric",
  "kind": "LinkedField",
  "name": "metrics",
  "plural": true,
  "selections": (v11/*: any*/)
},
v14 = [
  (v10/*: any*/),
  {
    "concreteType": "JiraCFODataRowConnection",
    "kind": "LinkedField",
    "name": "data",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraCFODataRowEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "timestamp"
              },
              (v12/*: any*/),
              (v13/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PerformanceNetworkViewQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PerformanceNetworkUserCharts"
      },
      {
        "args": [
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "dimension",
            "variableName": "dimension"
          },
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "PerformanceMonitoringHorizontalBarChart"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PerformanceNetworkViewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "cores",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "cpus"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "alias": "speed",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "network_downlink"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "alias": "protocol",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "http_protocol"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "alias": "os",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "os"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "alias": "browsers",
            "args": [
              (v5/*: any*/),
              {
                "kind": "Literal",
                "name": "dimensions",
                "value": [
                  {
                    "name": "browser_name"
                  }
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v9/*: any*/),
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": (v14/*: any*/)
          },
          {
            "alias": "ttvcAnalytics",
            "args": [
              (v5/*: any*/),
              {
                "items": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "name",
                        "variableName": "dimension"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "dimensions.0"
                  }
                ],
                "kind": "ListValue",
                "name": "dimensions"
              },
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": {
                      "type": "PERCENTILE",
                      "value": 0.5
                    },
                    "name": "ttvc90"
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "91ee270ba8a4a23aed34b9104b68a8d1847e24d7ecd5d2bb5ea88f0bed1ee6bf",
    "metadata": {},
    "name": "PerformanceNetworkViewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6203650689cd6f017f015501d7de4fcf";

export default node;
